export const CARE_ADVOCATE_PHONE = "(855) 360-1317"
const CARE_ADVOCATE_PHONE_DIGITS = "8553601317"
// tel: href that opens the device dialer. Works on mobile; on desktop the OS
// hands it to the registered call handler.
export const CARE_ADVOCATE_TEL_HREF = `tel:${CARE_ADVOCATE_PHONE_DIGITS}`
export const CARE_ADVOCATE_PHONE_LINK = `[${CARE_ADVOCATE_PHONE}](${CARE_ADVOCATE_TEL_HREF})`

// just an identifier, not a secret
export const PENDO_AGENT_ID = "c6bauLVXSUYWmTSZcLlkaVG6lig"
